import { DeepReadonlyObject } from 'rxdb';

import { ItineraryView, LegView, PriceType } from '@mopla/data-models';

import { ILegPriceInfo } from './types';

const toLegPriceInfo = (leg: LegView): ILegPriceInfo => {
	const original = leg.payment?.originalPriceInfo ?? null;
	const overwriting = leg.payment?.overwritingPriceInfo ?? null;

	return {
		legId: leg.legId,
		mode: leg.mode,
		effective: overwriting ?? original,
		original,
		isOverwritten: Boolean(overwriting),
		payment: leg.payment
			? {
					paymentState: leg.payment.paymentState,
					paymentForm: leg.payment.paymentForm,
			  }
			: null,
	};
};

/**
 * Whether the leg is paid in the app. Tariff and free legs carry a
 * `PricingView` too, so only the BE's `priceType` says.
 */
export const hasLegAmount = (info: ILegPriceInfo): boolean =>
	info.effective?.priceType === PriceType.MOPLA;

/**
 * Per-leg prices of an already booked ride, for the detail view's line items.
 * One entry per leg, walks included; a leg the BE priced carries `effective`.
 * A booking total belongs to `PassengerBookingView.originalPriceInfoAggregate`
 * and must not be summed up from here.
 */
export function getLegPriceInfos(
	itinerary: ItineraryView | null | undefined
): ILegPriceInfo[];
export function getLegPriceInfos(
	itinerary: DeepReadonlyObject<ItineraryView> | null | undefined
): ILegPriceInfo[];
export function getLegPriceInfos(
	itinerary:
		| ItineraryView
		| DeepReadonlyObject<ItineraryView>
		| null
		| undefined
): ILegPriceInfo[] {
	return ((itinerary?.legs ?? []) as LegView[]).map(toLegPriceInfo);
}
